import { compose } from 'redux';
import { connect } from 'react-redux';
import MazeModelScrollView from './MazeModelScrollView';
import selectors from '../../../rootSelectors';
import { setMazeScreenMode } from '../../mazeActions';
import { setAvatarInstructions, playAvatarAudio } from '../../../common/avatar/avatarActions';
import withAvatar from '../../../common/avatar/withAvatar';
import { stopAudio } from '../../../common/audio/audioActions';
import {
    blockScreen,
    unblockScreen,
    unmountScreen,
    activateNextButton,
    dehighlightDownButton,
    setIsScrollButtonClicked,
} from '../../../common/screen/screenActions';
import { SCROLL } from '../../../constants/assessmentItemType';
import {
    narrateReadyScript,
    onNextButtonClick,
    highlightCorrectResponses,
} from './MazeModelScrollActions';
import { SCROLL_ANIMATION_DURATION } from '../../../constants/slider';
import AvatarView from '../../../common/avatar/avatarView';
import { getAvatarPosition } from '../../../common/alex/AlexUtils';
import { setLanguageForMeasure } from '../../../common/utils/languageUtils';
import { dataDogAddWarning } from '../../../common/logging/datadog';

const mapStateToProps = (state, ownProps) => ({
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isGreyedOut: selectors.getIsScreenGreyedOut(state),
    isNextButtonActive: selectors.getIsNextButtonActive(state),
    isDataFetched: selectors.getIsMazeDataFetched(state),
    isDownButtonHighlighted: selectors.getIsDownButtonHighlighted(state),
    isScrollButtonClicked: selectors.getIsScrollButtonClicked(state),
    isOkButtonGreyedOut: selectors.getIsOkButtonGreyedOut(state),
    paragraphs: selectors.getMazeParagraphs(state, SCROLL),
    questions: selectors.getMazeQuestionItems(state, SCROLL),
    title: selectors.getMazeTitle(state, SCROLL),
    selectedResponses: selectors.getMazeSelectedResponses(state),
    screenMode: selectors.getMazeScreenMode(state),
    scrollDuration: SCROLL_ANIMATION_DURATION,
    isExtendedView: ownProps.isExtendedView,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchContent: () => {
        dispatch(ownProps.flowStrategy.fetchContent())
            .then(() => {
                setLanguageForMeasure(dispatch, ownProps.flowStrategy);
            })
            .catch(error => {
                dataDogAddWarning('Failed to fetch content:', { error });
                // eslint-disable-next-line no-console
                console.error('Failed to fetch content:', error);
            });
    },
    initModelScrollScreen: () => {
        dispatch(highlightCorrectResponses());
    },
    setScreenMode: screenMode => {
        dispatch(setMazeScreenMode(screenMode));
    },
    activeScript: () => {
        dispatch(blockScreen());
        dispatch(activateNextButton());
        return dispatch(narrateReadyScript(ownProps.flowStrategy.instructions[SCROLL])).then(() => {
            dispatch(unblockScreen());
        });
    },
    activateNextButton: () => dispatch(activateNextButton()),

    readyScript: () => {
        dispatch(setIsScrollButtonClicked(true));
        dispatch(dehighlightDownButton());
        dispatch(blockScreen());
        return dispatch(playAvatarAudio(ownProps.flowStrategy.instructions[SCROLL].clickOk)).then(
            () => {
                dispatch(setAvatarInstructions(ownProps.flowStrategy.instructions[SCROLL].clickOk));
                dispatch(unblockScreen());
            },
        );
    },
    onNext: () => {
        dispatch(
            onNextButtonClick(
                ownProps.flowStrategy.assessment,
                ownProps.flowStrategy.instructions[SCROLL],
            ),
        );
    },

    cleanup: () => {
        dispatch(stopAudio());
        dispatch(unmountScreen());
    },
});

const avatarMapStateToProps = (_, ownProps) => {
    const { isExtendedView } = ownProps;
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        extendedViewPosition: AvatarView.Position.LOWER_FAR_LEFT,
        defaultViewPosition: AvatarView.Position.MIDDLE_LEFT,
    };
    const position = getAvatarPosition(positionConfig, isExtendedView);
    return {
        position,
        instructions: ownProps.flowStrategy.instructions[SCROLL].scrollDownInstruction,
        animateAlex: true,
    };
};

const MazeModelScrollContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(MazeModelScrollView);

export default MazeModelScrollContainer;
